import { DynamicControl } from '@shared/models/dynamic-form-control.model';

export class ImageBoxControl extends DynamicControl<string> {
    controlType = 'imagebox';
    type: 'string';

    constructor(options: {} = {}) {
        super(options);
        this.type = options['type'] || '';
    }
}
